import stringifyParams from "@/utils/stringifyParams";

const getGoogleShareUrl = () => {
  const currentUrl = window.location.href;
  const currentUrlWithContentIdPath = currentUrl.split("?")[0];
  const googleShareParams = {
    url: currentUrlWithContentIdPath,
    utm_source: "google-classroom",
    utm_campaign: "share",
    utm_medium: "web",
  };
  return `https://classroom.google.com/u/0/share${stringifyParams(googleShareParams)}`;
};

export default getGoogleShareUrl;
